import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshanishingnapurcab() {



    const cardData = {

keyword: "Pune to Shani Shingnapur Cab",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable Pune to Shani Shingnapur Cab services for families, devotees, and spiritual travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth pilgrimage journey. Our service includes doorstep pickup from Pune, flexible one-way and round-trip packages, 24/7 support, and transparent pricing, ensuring a peaceful and hassle-free darshan experience at Shani Shingnapur.",

topPlaces: [
    {
        title: "Shri Shani Shingnapur Temple",
        description:
            "Shri Shani Shingnapur Temple is one of the most famous spiritual destinations in Maharashtra, dedicated to Lord Shani. The village is known for its unique tradition of houses without doors and strong belief in divine justice and protection."
    },
    {
        title: "Open-Air Shani Idol Shrine",
        description:
            "The main shrine features a self-emerged black stone idol of Lord Shani placed in the open air. Devotees believe the deity protects the entire village and fulfills wishes of sincere worshippers."
    },
    {
        title: "Shani Dev Pooja Mandap",
        description:
            "The Pooja Mandap area is where devotees perform rituals, oil offerings, and prayers to Lord Shani. It is a key spiritual activity zone within the temple complex."
    },
    {
        title: "Shingnapur Village Streets",
        description:
            "The village surrounding the temple reflects a unique lifestyle where homes traditionally had no doors, symbolizing deep faith in Lord Shani’s protection and justice."
    },
    {
        title: "Ahmednagar Route Temples",
        description:
            "The route from Pune to Shani Shingnapur passes through several small temples and spiritual stops in the Ahmednagar region, making the journey peaceful and devotional."
    },
    {
        title: "Shirdi Sai Baba Temple (Nearby Extension)",
        description:
            "Many pilgrims combine their Shani Shingnapur trip with Shirdi darshan to visit Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi for a complete spiritual experience."
    },
    {
        title: "Nevasa Sant Dnyaneshwar Region",
        description:
            "Nevasa is a spiritually important nearby region associated with Sant Dnyaneshwar Maharaj, often visited as part of extended pilgrimage tours."
    },
    {
        title: "Sonai Village Temples",
        description:
            "Sonai village near Shani Shingnapur has several small temples and traditional religious spots that add cultural depth to the journey."
    },
    {
        title: "Ahilyanagar (Ahmednagar) City Temples",
        description:
            "Ahmednagar city en route offers historical temples and spiritual landmarks that many travelers visit during their cab journey."
    },
    {
        title: "Devotional Highway Route",
        description:
            "The Pune to Shani Shingnapur highway route is filled with devotional energy, rural landscapes, and pilgrimage traffic, making the cab journey peaceful and spiritually enriching."
    }
],



services: [
  {
    name: "Pune to Shani Shingnapur Cab Service",
    description: "Rising Cab Service offers Pune to Shani Shingnapur Cab Service for a safe and comfortable pilgrimage journey to the famous Shani Shingnapur temple. We provide well-maintained AC Sedan, SUV, Innova Crysta, and Tempo Traveller options with professional drivers, doorstep pickup, and 24x7 booking support. Ideal for families, groups, and devotees seeking a smooth and peaceful spiritual travel experience."
  },
  {
    name: "Pune to Shani Shingnapur Taxi Service",
    description: "Book Pune to Shani Shingnapur Taxi Service with Rising Cab Service for reliable intercity travel designed for temple visitors. Our experienced chauffeurs ensure safe driving, timely pickup, clean vehicles, and a comfortable journey experience for all passengers traveling for darshan."
  },
  {
    name: "Pune to Shani Shingnapur Cab Booking",
    description: "Rising Cab Service provides instant Pune to Shani Shingnapur Cab Booking with multiple vehicle options, easy confirmation, and transparent pricing. Whether you need one way or round trip travel, we offer hassle-free booking with 24x7 customer assistance."
  },
  {
    name: "Pune to Shani Shingnapur One Way Cab",
    description: "Our Pune to Shani Shingnapur One Way Cab service is perfect for passengers looking for affordable drop-only travel to the temple town. We offer clean AC vehicles, professional drivers, and budget-friendly fares for a smooth and safe pilgrimage journey."
  },
  {
    name: "Pune to Shani Shingnapur Round Trip Taxi",
    description: "Rising Cab Service offers Pune to Shani Shingnapur Round Trip Taxi for same-day or flexible return travel plans. Enjoy comfortable vehicles, safe driving, and waiting time options suitable for family and group temple visits."
  },
  {
    name: "Pune to Shani Shingnapur Darshan Taxi",
    description: "Book Pune to Shani Shingnapur Darshan Taxi for a complete spiritual travel experience to Shani Shingnapur temple. We ensure timely arrival, flexible stops for darshan, and comfortable AC rides for a peaceful pilgrimage journey."
  },
  {
    name: "Pune to Shani Shingnapur Innova Taxi",
    description: "Rising Cab Service offers Pune to Shani Shingnapur Innova Taxi for premium comfort, spacious seating, and smooth highway travel. Ideal for families and groups seeking luxury, safety, and comfort during temple visits."
  },
  {
    name: "Pune to Shani Shingnapur SUV Cab Service",
    description: "Our Pune to Shani Shingnapur SUV Cab Service is ideal for larger families and groups needing extra space and comfort. We provide well-maintained SUVs with AC, experienced drivers, and safe long-distance travel for a hassle-free pilgrimage."
  },
  {
    name: "Pune to Shani Shingnapur Sedan Cab Service",
    description: "Book Pune to Shani Shingnapur Sedan Cab Service for affordable and comfortable travel for small families and individuals. Our clean, air-conditioned sedans ensure smooth and budget-friendly pilgrimage transportation."
  },
  {
    name: "Pune to Shani Shingnapur Temple Tour Package",
    description: "Rising Cab Service provides Pune to Shani Shingnapur Temple Tour Package with complete travel solutions including round trip cab service, flexible itinerary, and professional drivers for a smooth spiritual journey."
  },
  {
    name: "Pune to Shani Shingnapur Religious Tour",
    description: "Our Pune to Shani Shingnapur Religious Tour is designed for devotees seeking a peaceful and well-organized pilgrimage experience. We provide comfortable transport, flexible stops, and safe travel arrangements for temple visits."
  },
  {
    name: "Pune to Shani Shingnapur Luxury Cab",
    description: "Rising Cab Service offers Pune to Shani Shingnapur Luxury Cab with premium vehicles like Innova Crysta and SUV options for maximum comfort, safety, and elegant long-distance pilgrimage travel experience."
  },
  {
    name: "Pune to Shani Shingnapur Tourist Taxi",
    description: "Book Pune to Shani Shingnapur Tourist Taxi for a convenient and enjoyable temple trip with professional drivers, clean vehicles, and flexible travel plans suitable for families and groups."
  },
  {
    name: "Pune to Shani Shingnapur Weekend Trip Cab",
    description: "Our Pune to Shani Shingnapur Weekend Trip Cab service is ideal for short spiritual getaways. We offer flexible pickup, comfortable vehicles, and smooth travel experience for weekend temple visits."
  },
  {
    name: "Pune to Shani Shingnapur Taxi Fare",
    description: "Rising Cab Service provides transparent Pune to Shani Shingnapur Taxi Fare with affordable pricing based on vehicle type and travel plan. Enjoy budget-friendly, safe, and reliable pilgrimage travel with no hidden charges."
  }
],

tableData: [
  ["Pune to Shani Shingnapur Cab Service", "Pune to Shani Shingnapur Taxi Service"],
  ["Pune to Shani Shingnapur Cab Booking", "Pune to Shani Shingnapur One Way Cab"],
  ["Pune to Shani Shingnapur Round Trip Taxi", "Pune to Shani Shingnapur Darshan Taxi"],
  ["Pune to Shani Shingnapur Innova Taxi", "Pune to Shani Shingnapur Luxury Cab"],
  ["Pune to Shani Shingnapur Tourist Taxi", "Pune to Shani Shingnapur Weekend Trip Cab"],
  ["Pune to Shani Shingnapur Sedan Cab Service", "Pune to Shani Shingnapur SUV Cab Service"],
  ["Pune to Shani Shingnapur Temple Tour Package", "Pune to Shani Shingnapur Religious Tour"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Shani Shingnapur Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Shani Shingnapur cab transportation for devotees, families, senior citizens, and spiritual travelers seeking a peaceful pilgrimage experience."
    },
    {
        WhyChooseheading: "Convenient Shani Dev Darshan Travel",
        WhyChoosedescription: "Travel comfortably to the famous Shani Shingnapur Temple, one of India's most revered shrines dedicated to Lord Shani."
    },
    {
        WhyChooseheading: "Ideal for Same-Day Religious Trips",
        WhyChoosedescription: "Many devotees prefer same-day Shani Shingnapur Darshan packages, allowing them to complete their pilgrimage comfortably and return to Pune on the same day."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Group Size",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for individual travelers, families, and groups."
    },
    {
        WhyChooseheading: "Combine Multiple Pilgrimage Destinations",
        WhyChoosedescription: "Travelers can include Shirdi Sai Baba Temple, Shani Shingnapur, Nashik, Trimbakeshwar, and other religious destinations in a customized tour package."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Professional Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with temple routes and ensure safe, smooth, and comfortable travel throughout the journey."
    },
    {
        WhyChooseheading: "Perfect for Family and Senior Citizen Travel",
        WhyChoosedescription: "Private cab travel provides flexibility and convenience, making temple visits comfortable for devotees of all age groups."
    }
]
};

const faqData = [
    {
        question: "Why is Shani Shingnapur famous among devotees?",
        answer: "Shani Shingnapur is renowned for its self-manifested idol of Lord Shani and attracts devotees from across India seeking blessings and spiritual fulfillment."
    },
    {
        question: "Can I book a one-way cab from Pune to Shani Shingnapur?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Can Shirdi and Shani Shingnapur be covered in a single trip?",
        answer: "Yes, many devotees combine Shirdi Sai Baba Darshan and Shani Shingnapur Temple visits in one pilgrimage tour."
    },
    {
        question: "Which vehicle is suitable for family temple visits?",
        answer: "Ertiga and Innova Crysta are popular choices because they provide spacious seating and comfortable travel."
    },
    {
        question: "Are Tempo Travellers available for religious groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, bhajan mandals, and pilgrimage tours."
    },
    {
        question: "Can same-day return trips be arranged from Pune?",
        answer: "Yes, same-day Shani Shingnapur Darshan packages are available depending on the travel schedule."
    },
    {
        question: "Is the service suitable for senior citizens?",
        answer: "Yes, private cab transportation offers comfortable travel and flexible schedules, making it ideal for elderly devotees."
    },
    {
        question: "Can additional temples be included in the itinerary?",
        answer: "Yes, travelers can include Shirdi, Trimbakeshwar, Nashik, Grishneshwar, and other religious destinations."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, devotees can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I book a Pune to Shani Shingnapur Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ashok Jadhav",
        feedback:
            "The Shani Shingnapur Darshan trip was planned perfectly. We completed our temple visit comfortably, and the travel arrangements were handled very professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Ujwala Kulkarni",
        feedback:
            "Our family combined Shirdi and Shani Shingnapur in one journey. The vehicle was clean, the ride was comfortable, and the entire pilgrimage experience was truly satisfying.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Shani Shingnapur Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-shani-shingnapur-cab.jpg",
"description": "Book Pune to Shani Shingnapur Cab Service with Rising Cab Service for safe and comfortable spiritual travel to Shani Shingnapur temple. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for darshan trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-shani-shingnapur-cab"
}
};









    return (
        <div>

<Helmet>
  <title>Pune to Shani Shingnapur Cab Service | Temple Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Shani Shingnapur Cab Service for safe and comfortable temple travel. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at best prices."
/>

<meta
 name="keywords"
 content="pune to shani shingnapur cab, pune to shani shingnapur taxi, cab from pune to shani shingnapur, taxi from pune to shani shingnapur, pune to shani shingnapur cab service, pune to shani shingnapur taxi fare, pune to shani shingnapur one way cab, pune to shani shingnapur round trip taxi, pune to shani shingnapur cab booking, cheap pune to shani shingnapur cab, best pune to shani shingnapur taxi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshanishingnapurcab;